import { Box, HStack, Text } from '@rbilabs/universal-components';

import { TableHeader } from 'components/nutrition/v2/table-header';
import Picture from 'components/picture';
import { t } from 'state/intl/translations';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'state/launchdarkly/flags';
import { mapImageResourceToSanityImage } from 'state/unified-menu/utils';

import { IngredientsType } from './types';

type ItemIngredientsProps = {
  ingredients: IngredientsType[];
};

const IngredientsText = Text.withConfig({
  variant: 'copyTwo',
  fontWeight: 'bold',
  fontSize: 'sm',
});

export const Ingredients = HStack.withConfig({
  justifyContent: 'flex-start',
  marginTop: 1,
  focusable: true,
});

export const ItemIngredients = ({ ingredients }: ItemIngredientsProps) => {
  const enableFeatureItemNutritionIngredients = useFlag(
    LaunchDarklyFlag.ENABLE_FEATURE_ITEM_NUTRITION_INGREDIENTS
  );

  const orderedIngredients = ingredients?.sort(
    (a, b) => (a.ingredients?.length || 0) - (b.ingredients?.length || 0)
  );

  if (!enableFeatureItemNutritionIngredients || ingredients?.length === 0) {
    return null;
  }

  const getFormattedIngredient = (name?: string | null, ingredients?: string[] | null) => {
    const isOnlyIngredient = ingredients?.length === 1 && ingredients[0] === name;
    const hasNoIngredients = !ingredients || ingredients.length === 0;
    if (isOnlyIngredient || hasNoIngredients) {
      return (
        <>
          <Text>•</Text> {name}
        </>
      );
    }
    return (
      <>
        <Text>•</Text> {name}:{' '}
        <Text fontWeight="normal" textTransform="capitalize">
          {ingredients?.join(', ')}
        </Text>
      </>
    );
  };

  return (
    <Box maxWidth="900">
      <TableHeader testID="nutrition-ingredients-header" title={t('additionalInfoIngredients')} />
      {orderedIngredients?.map(({ name, image, ingredients }, index: number) => {
        const normalizedIngredients = ingredients
          ? ([...ingredients].filter(x => x != null) as string[])
          : null;
        return (
          <Ingredients key={index}>
            {image && (
              <Box>
                <Picture
                  image={mapImageResourceToSanityImage(image ?? '')}
                  alt="itemImage"
                  objectFitContain
                  width={100}
                  height={100}
                  alignSelf="center"
                />
              </Box>
            )}
            <Box width={image ? '90%' : '100%'}>
              <IngredientsText textAlign="left" focusable>
                {getFormattedIngredient(name, normalizedIngredients)}
              </IngredientsText>
            </Box>
          </Ingredients>
        );
      })}
    </Box>
  );
};
